import { KeyCodes } from '@fluentui/react/lib/Utilities';

// Note: right now this only supports English.
// WI 84785 tracks supporting non-English layouts as needed
export default function isKeycodePrintable(which: number): boolean {
    if (
        which === KeyCodes.space ||
        (which >= KeyCodes.zero && which <= KeyCodes.nine) || // numbers
        (which >= KeyCodes.a && which <= KeyCodes.z) || // letters
        (which >= KeyCodes.zero_numpad && which <= KeyCodes.nine_numpad) || // numpad
        (which >= KeyCodes.semicolon && which <= KeyCodes.graveAccent) || // semi-colon, equal sign, comma, dash, period, forward slash, tilde
        (which >= KeyCodes.openBracket && which <= KeyCodes.singleQuote) // open bracket, backslash, close bracket, single apostrophe
    ) {
        return true;
    }

    return false;
}
